/*
 * This folder collects a bunch of React Context implementations for common data.
 * These contexts are initialized with default values from bootstrap data.
 *
 * ⚠️  CAUTION TO IMPLEMENTERS  ⚠️
 * If the bootstrap data is not present on the page, the contexts will not have a default value
 * and you will have to provide the context value yourself.
 */

export { AvailableFontsContext, withAvailableFonts } from './availableFonts';
export { CsrfTokenContext, withCsrfToken, useCsrfToken } from './csrfToken';
export { FlagsContext, withFlags, useFlags } from './flags';
export { RootDomainContext, withRootDomain, useRootDomain } from './rootDomain';
export { UserContext, withUser } from './user';
